import { render, staticRenderFns } from "./ListChooser.vue?vue&type=template&id=8ec2def2&"
import script from "./ListChooser.vue?vue&type=script&lang=js&"
export * from "./ListChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports